


/**
* Guide Stream Session Recording Options
*/
export enum RecordingOption{
    /**
    * Session is always recorded with no option to modify
    */
    Always = 0,
    /**
    * Optionally start and stop recording
    */
    Optional = 1,
    /**
    * Never record the session at all
    */
    Never = 2
}

